module.exports = __webpack_public_path__ + "static/img/b15.986d7a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b15.jpg
// module id = 6Atc
// module chunks = 1